// extracted by mini-css-extract-plugin
export default {"brandPromo":"yF-z","carousel":"zF-z"};